export const setCustomerInfoLocalStorage = objectInfo => {
  window.localStorage.setItem('infoCustomerEmgea', JSON.stringify(objectInfo))
}

export const getCustomerInfoLocalStorage = () => {
  return JSON.parse(window.localStorage.getItem('infoCustomerEmgea')) || {}
}
